export default __webpack_public_path__ + "static/4-cdd2aae5a3617acf03eee33d823ff597.jpg";